/**
 * Copyright (C) 2018-2022
 * All rights reserved, Designed By www.joolun.com
 * 注意：
 * 本软件为www.joolun.com开发研制，未经购买不得使用
 * 购买后可获得全部源代码（禁止转卖、分享、上传到码云、github等开源平台）
 * 一经发现盗用、分享等行为，将追究法律责任，后果自负
 */
/**
 * 商城常用常量
 */
export default {
  // 客户端类型：小程序，普通H5，微信H5，APPapp，pcH5 "MA";
  // "MA";"H5";"H5-WX";"H5-PC";"APP";
  clientType: {
    'MA': {
      'title': '小程序'
    },
    'H5': {
      'title': 'H5'
    },
    'H5-WX': {
      'title': '公众号'
    },
    'H5-PC': {
      'title': 'PC'
    },
    'APP': {
      'title': 'APP'
    }
  }
};